import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import { GoogleReviews } from '../../components/feature/GoogleReviews';

export default function EmpresasPage() {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [formData, setFormData] = useState({
    nombreEmpresa: '',
    tipoNegocio: '',
    horarioConsumo: '',
    numeroSuministros: '',
    telefono: '',
    email: '',
    observaciones: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validar campos requeridos
    if (!formData.nombreEmpresa || !formData.tipoNegocio || !formData.telefono || !formData.email) {
      alert('Por favor, completa todos los campos obligatorios');
      return;
    }

    // Guardar en localStorage
    const solicitudes = JSON.parse(localStorage.getItem('solicitudes') || '[]');
    const nuevaSolicitud = {
      ...formData,
      tipo: 'Auditoría Empresarial',
      fecha: new Date().toISOString()
    };
    solicitudes.push(nuevaSolicitud);
    localStorage.setItem('solicitudes', JSON.stringify(solicitudes));

    // Redirigir a solicitudes
    navigate('/solicitudes');
  };

  const handleWhatsApp = () => {
    const mensaje = encodeURIComponent('Hola, me gustaría solicitar una auditoría energética gratuita para mi empresa.');
    window.open(`https://wa.me/34123456789?text=${mensaje}`, '_blank');
  };

  const handleWhatsAppExcedentes = () => {
    const mensaje = encodeURIComponent('Hola, tengo placas solares y quiero revisar mis excedentes eléctricos.');
    window.open(`https://wa.me/34123456789?text=${mensaje}`, '_blank');
  };

  const handleWhatsAppSolarEmpresa = () => {
    const mensaje = encodeURIComponent('Hola, me gustaría solicitar un estudio solar para mi empresa.');
    window.open(`https://wa.me/34123456789?text=${mensaje}`, '_blank');
  };

  const handleWhatsAppSolarCasa = () => {
    const mensaje = encodeURIComponent('Hola, quiero información sobre instalación de placas solares para mi hogar.');
    window.open(`https://wa.me/34123456789?text=${mensaje}`, '_blank');
  };

  const sectores = [
    {
      icon: 'ri-restaurant-2-line',
      titulo: 'Restaurantes y bares',
      descripcion: 'Optimización de consumo en cocinas, climatización y horarios de apertura'
    },
    {
      icon: 'ri-cake-3-line',
      titulo: 'Panaderías y obradores',
      descripcion: 'Gestión de hornos, cámaras frigoríficas y producción nocturna'
    },
    {
      icon: 'ri-hotel-line',
      titulo: 'Hoteles y alojamientos',
      descripcion: 'Control de climatización, agua caliente y servicios 24h'
    },
    {
      icon: 'ri-store-2-line',
      titulo: 'Comercios y tiendas',
      descripcion: 'Iluminación, climatización y horarios comerciales'
    },
    {
      icon: 'ri-car-line',
      titulo: 'Talleres y naves',
      descripcion: 'Maquinaria industrial, iluminación y sistemas de producción'
    },
    {
      icon: 'ri-plant-line',
      titulo: 'Invernaderos e industrias',
      descripcion: 'Climatización, riego, iluminación y procesos industriales'
    }
  ];

  const soluciones = [
    {
      icon: 'ri-flashlight-line',
      titulo: 'Optimización de contratos eléctricos',
      descripcion: 'Ajustamos potencias y tarifas para que pagues solo lo necesario'
    },
    {
      icon: 'ri-fire-line',
      titulo: 'Ajuste de tramos de gas',
      descripcion: 'RL3, RL4 y superiores correctamente configurados'
    },
    {
      icon: 'ri-sun-line',
      titulo: 'Instalación de placas solares',
      descripcion: 'Sistemas fotovoltaicos diseñados para tu actividad empresarial'
    },
    {
      icon: 'ri-arrow-left-right-line',
      titulo: 'Gestión de excedentes eléctricos',
      descripcion: 'Maximiza el retorno de tu energía solar excedente'
    },
    {
      icon: 'ri-line-chart-line',
      titulo: 'Reducción de costes energéticos',
      descripcion: 'Análisis completo para identificar todas las oportunidades de ahorro'
    }
  ];

  const analisis = [
    { icon: 'ri-flashlight-line', texto: 'Consumo eléctrico real y curvas horarias' },
    { icon: 'ri-plug-line', texto: 'Potencias contratadas' },
    { icon: 'ri-fire-line', texto: 'Tramos de gas (RL3, RL4 y superiores)' },
    { icon: 'ri-alert-line', texto: 'Penalizaciones y sobrecostes' },
    { icon: 'ri-line-chart-line', texto: 'Posibilidades de optimización' }
  ];

  const beneficios = [
    { icon: 'ri-money-euro-circle-line', texto: 'Reducción directa de costes fijos' },
    { icon: 'ri-file-list-3-line', texto: 'Contratos ajustados a tu actividad' },
    { icon: 'ri-file-text-line', texto: 'Facturas más claras y predecibles' },
    { icon: 'ri-user-heart-line', texto: 'Asesor energético de confianza' }
  ];

  const beneficiosGlobales = [
    { icon: 'ri-money-euro-circle-line', texto: 'Menor coste energético' },
    { icon: 'ri-arrow-left-right-line', texto: 'Aprovechamiento total de excedentes' },
    { icon: 'ri-sun-line', texto: 'Energía solar bien optimizada' },
    { icon: 'ri-user-star-line', texto: 'Un único asesor para todo' }
  ];

  const faqs = [
    {
      pregunta: '¿Tiene coste el estudio energético?',
      respuesta: 'No. La auditoría inicial es completamente gratuita y sin compromiso.'
    },
    {
      pregunta: '¿Se interrumpe el suministro durante el cambio?',
      respuesta: 'No. El cambio es completamente administrativo, sin cortes ni interrupciones en tu actividad.'
    },
    {
      pregunta: '¿Hay permanencia en los contratos?',
      respuesta: 'Buscamos siempre opciones flexibles sin permanencia para que tengas libertad total.'
    },
    {
      pregunta: '¿Trabajáis con varios suministros?',
      respuesta: 'Sí. Gestionamos uno o varios puntos de suministro, tanto de luz como de gas.'
    },
    {
      pregunta: '¿Cuánto tiempo tarda el proceso?',
      respuesta: 'La auditoría inicial tarda 24-48h. El cambio completo suele completarse en 2-4 semanas.'
    },
    {
      pregunta: '¿Qué documentación necesito?',
      respuesta: 'Solo tus últimas facturas de luz y/o gas. Nosotros nos encargamos del resto.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/a65a81e75c6574b739988ef7827011e4.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-6 py-20 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Reduce el coste energético de tu empresa y aprovecha tus excedentes
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-white/90">
            Optimizamos luz, gas, contratos duales, excedentes solares e instalaciones fotovoltaicas para empresas.
          </p>

          <div className="flex flex-col gap-3 mb-10 max-w-xl mx-auto">
            {['Auditoría energética profesional', 'Gestión de excedentes eléctricos', 'Instalaciones solares para empresas', 'Atención personalizada'].map((item, index) => (
              <div key={index} className="flex items-center gap-3 text-left">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-400"></i>
                </div>
                <span className="text-lg">{item}</span>
              </div>
            ))}
          </div>

          <button
            onClick={handleWhatsApp}
            className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            📊 Solicitar auditoría energética gratuita
          </button>
        </div>
      </section>

      {/* El Problema Real */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-6 text-gray-900">
            Muchas empresas pagan más… incluso produciendo su propia energía
          </h2>
          <p className="text-xl text-gray-700 mb-8 leading-relaxed">
            Empresas con o sin placas solares suelen perder dinero por:
          </p>
          
          <div className="grid md:grid-cols-3 gap-6 mb-10">
            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-warning-line text-5xl text-red-500"></i>
              </div>
              <p className="text-lg font-semibold text-gray-800">Contratos mal ajustados</p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4">
                <i className="ri-arrow-left-right-line text-5xl text-orange-500"></i>
              </div>
              <p className="text-lg font-semibold text-gray-800">Excedentes solares mal compensados</p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4">
                <i className="ri-sun-line text-5xl text-yellow-500"></i>
              </div>
              <p className="text-lg font-semibold text-gray-800">Instalaciones fotovoltaicas no optimizadas</p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-orange-50 to-red-50 border-l-4 border-orange-500 p-6 rounded-lg">
            <p className="text-xl font-semibold text-gray-900">
              Producir energía y no aprovecharla correctamente también es perder dinero.
            </p>
          </div>
        </div>
      </section>

      {/* Qué Solucionamos */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4 text-gray-900">
              Soluciones energéticas completas para empresas
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {soluciones.map((solucion, index) => (
              <div key={index} className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-100">
                <div className="w-16 h-16 flex items-center justify-center mb-6 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl">
                  <i className={`${solucion.icon} text-4xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold mb-3 text-gray-900">{solucion.titulo}</h3>
                <p className="text-gray-600 leading-relaxed">{solucion.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Excedentes Solares */}
      <section className="py-20 bg-gradient-to-b from-yellow-50 to-orange-50">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full">
              <i className="ri-arrow-left-right-line text-5xl text-white"></i>
            </div>
            <h2 className="text-4xl font-bold mb-6 text-gray-900">
              ¿Tienes placas solares y no aprovechas tus excedentes?
            </h2>
            <p className="text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
              Si tu empresa produce más energía de la que consume, esos excedentes deben compensarse correctamente para maximizar el ahorro.
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-2xl p-10 mb-10">
            <h3 className="text-2xl font-bold mb-8 text-center text-gray-900">Qué hacemos:</h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full text-white text-2xl font-bold">
                  1
                </div>
                <h4 className="text-lg font-bold mb-2 text-gray-900">Analizamos tu producción y consumo</h4>
                <p className="text-gray-600">Estudiamos tus patrones de generación y uso energético</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full text-white text-2xl font-bold">
                  2
                </div>
                <h4 className="text-lg font-bold mb-2 text-gray-900">Optimizamos la compensación de excedentes</h4>
                <p className="text-gray-600">Configuramos la mejor forma de aprovechar tu energía sobrante</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full text-white text-2xl font-bold">
                  3
                </div>
                <h4 className="text-lg font-bold mb-2 text-gray-900">Ajustamos tu contrato</h4>
                <p className="text-gray-600">Maximizamos el retorno económico de tu instalación</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-red-50 to-orange-50 border-l-4 border-orange-500 p-6 rounded-lg mb-8">
            <p className="text-xl font-semibold text-gray-900 text-center">
              Cada kWh excedente mal gestionado es dinero perdido.
            </p>
          </div>

          <div className="text-center">
            <button
              onClick={handleWhatsAppExcedentes}
              className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              🔄 Revisar mis excedentes
            </button>
          </div>
        </div>
      </section>

      {/* Instalaciones Solares Empresas */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full">
              <i className="ri-sun-line text-5xl text-white"></i>
            </div>
            <h2 className="text-4xl font-bold mb-6 text-gray-900">
              Instalaciones solares a medida para empresas
            </h2>
            <p className="text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto mb-10">
              Diseñamos e instalamos sistemas fotovoltaicos adaptados a la actividad de tu empresa, maximizando rentabilidad y ahorro.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-10">
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-8 rounded-2xl shadow-lg text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-euro-circle-line text-5xl text-green-600"></i>
              </div>
              <h3 className="text-lg font-bold mb-2 text-gray-900">Reducción inmediata del gasto energético</h3>
              <p className="text-gray-600">Ahorra desde el primer día de instalación</p>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-8 rounded-2xl shadow-lg text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-5xl text-blue-600"></i>
              </div>
              <h3 className="text-lg font-bold mb-2 text-gray-900">Rentabilidad a medio y largo plazo</h3>
              <p className="text-gray-600">Inversión que se amortiza rápidamente</p>
            </div>
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-8 rounded-2xl shadow-lg text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-battery-charge-line text-5xl text-purple-600"></i>
              </div>
              <h3 className="text-lg font-bold mb-2 text-gray-900">Opciones con batería virtual o compensación</h3>
              <p className="text-gray-600">Flexibilidad según tus necesidades</p>
            </div>
          </div>

          <div className="text-center">
            <button
              onClick={handleWhatsAppSolarEmpresa}
              className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-10 py-4 rounded-full text-lg font-semibold hover:from-yellow-600 hover:to-orange-600 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              ☀️ Solicitar estudio solar para mi empresa
            </button>
          </div>
        </div>
      </section>

      {/* También para Particulares */}
      <section className="py-20 bg-gradient-to-b from-blue-50 to-cyan-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="bg-white rounded-3xl shadow-2xl p-10 text-center">
            <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-full">
              <i className="ri-home-smile-line text-5xl text-white"></i>
            </div>
            <h2 className="text-3xl font-bold mb-4 text-gray-900">
              Energía solar también para tu hogar
            </h2>
            <p className="text-xl text-gray-700 mb-8 leading-relaxed">
              Si tienes vivienda, también gestionamos instalaciones solares para particulares, con o sin batería virtual.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-8">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-3xl text-green-500"></i>
                </div>
                <span className="text-left font-semibold text-gray-800">Ahorro desde el primer mes</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-3xl text-green-500"></i>
                </div>
                <span className="text-left font-semibold text-gray-800">Aprovechamiento de excedentes</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-3xl text-green-500"></i>
                </div>
                <span className="text-left font-semibold text-gray-800">Gestión integral</span>
              </div>
            </div>

            <button
              onClick={handleWhatsAppSolarCasa}
              className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-10 py-4 rounded-full text-lg font-semibold hover:from-blue-600 hover:to-cyan-600 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              🏠☀️ Quiero placas solares en casa
            </button>
          </div>
        </div>
      </section>

      {/* A Quién Va Dirigido */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4 text-gray-900">
              Este servicio es ideal para:
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {sectores.map((sector, index) => (
              <div key={index} className="bg-gradient-to-br from-blue-50 to-cyan-50 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-blue-100">
                <div className="w-16 h-16 flex items-center justify-center mb-6 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl">
                  <i className={`${sector.icon} text-4xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold mb-3 text-gray-900">{sector.titulo}</h3>
                <p className="text-gray-600 leading-relaxed">{sector.descripcion}</p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <button
              onClick={handleWhatsApp}
              className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-10 py-4 rounded-full text-lg font-semibold hover:from-blue-600 hover:to-cyan-600 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              ⚡ Calcular ahorro para mi empresa
            </button>
          </div>
        </div>
      </section>

      {/* Qué Analizamos */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-6 text-gray-900">
              Qué revisamos en tu empresa
            </h2>
          </div>

          <div className="bg-white rounded-3xl shadow-2xl p-10">
            <div className="space-y-6">
              {analisis.map((item, index) => (
                <div key={index} className="flex items-start gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors">
                  <div className="w-12 h-12 flex items-center justify-center flex-shrink-0 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl">
                    <i className={`${item.icon} text-2xl text-white`}></i>
                  </div>
                  <p className="text-lg text-gray-800 pt-2">{item.texto}</p>
                </div>
              ))}
            </div>

            <div className="mt-10 bg-gradient-to-r from-blue-50 to-cyan-50 border-l-4 border-blue-500 p-6 rounded-lg">
              <p className="text-lg font-semibold text-gray-900">
                Cada empresa tiene un patrón de consumo distinto. No usamos soluciones genéricas.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Cómo Trabajamos */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4 text-gray-900">
              Así ayudamos a empresas y particulares a ahorrar más
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full text-white text-3xl font-bold shadow-xl">
                1
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900">Auditoría energética</h3>
              <p className="text-gray-600 leading-relaxed">
                Consumo, contratos, excedentes y posibilidades solares.
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full text-white text-3xl font-bold shadow-xl">
                2
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900">Propuesta personalizada</h3>
              <p className="text-gray-600 leading-relaxed">
                Tarifas, compensación y/o instalación fotovoltaica.
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full text-white text-3xl font-bold shadow-xl">
                3
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900">Gestión integral</h3>
              <p className="text-gray-600 leading-relaxed">
                Nos encargamos de todo el proceso.
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-l-4 border-green-500 p-6 rounded-lg">
            <p className="text-xl font-semibold text-gray-900 text-center">
              Si no hay mejora real, te lo decimos con total transparencia.
            </p>
          </div>
        </div>
      </section>

      {/* Beneficios Globales */}
      <section className="py-20 bg-gradient-to-b from-green-50 to-emerald-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-6 text-gray-900">
              Ventajas de una asesoría energética integral
            </h2>
          </div>

          <div className="bg-white rounded-3xl shadow-2xl p-10">
            <div className="grid md:grid-cols-2 gap-8 mb-10">
              {beneficiosGlobales.map((beneficio, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                    <i className={`${beneficio.icon} text-4xl text-green-600`}></i>
                  </div>
                  <p className="text-lg text-gray-800 pt-2">{beneficio.texto}</p>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-l-4 border-green-500 p-6 rounded-lg">
              <p className="text-xl font-semibold text-gray-900 text-center">
                Cuando todo está bien integrado, el ahorro se multiplica.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Prueba Social */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4 text-gray-900">
              Empresas y hogares que ya confían en nosotros
            </h2>
            <p className="text-xl text-gray-600">
              Negocios locales que ya están pagando menos energía.
            </p>
          </div>

          <GoogleReviews />
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4 text-gray-900">
              Preguntas frecuentes de empresas
            </h2>
          </div>

          <div className="space-y-4 mb-12">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <span className="text-lg font-semibold text-gray-900 pr-4">{faq.pregunta}</span>
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className={`ri-arrow-${openFaq === index ? 'up' : 'down'}-s-line text-2xl text-blue-600`}></i>
                  </div>
                </button>
                {openFaq === index && (
                  <div className="px-8 pb-6">
                    <p className="text-gray-600 leading-relaxed">{faq.respuesta}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={handleWhatsApp}
              className="bg-gradient-to-r from-green-500 to-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:from-green-600 hover:to-green-700 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              Contactar por WhatsApp
            </button>
            <a
              href="tel:+34123456789"
              className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:from-blue-600 hover:to-blue-700 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line text-2xl"></i>
              Llamar ahora
            </a>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-20 bg-gradient-to-br from-orange-500 via-red-500 to-pink-500 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Convierte tu energía en ahorro real
          </h2>
          <p className="text-xl md:text-2xl mb-10 text-white/90">
            Revisamos tu contrato, tus excedentes y tu potencial solar sin coste.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center mb-8">
            <button
              onClick={handleWhatsApp}
              className="bg-white text-orange-600 px-10 py-5 rounded-full text-lg font-bold hover:bg-gray-100 transition-all shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              🚀 Solicitar auditoría energética gratuita
            </button>
            <button
              onClick={handleWhatsApp}
              className="bg-green-500 text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-green-600 transition-all shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              💬 Prefiero hablar por WhatsApp
            </button>
          </div>

          <div className="flex flex-col sm:flex-row gap-6 justify-center text-sm">
            <div className="flex items-center justify-center gap-2">
              <i className="ri-checkbox-circle-fill text-xl"></i>
              <span>Sin compromiso</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <i className="ri-checkbox-circle-fill text-xl"></i>
              <span>Respuesta en 24h</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <i className="ri-checkbox-circle-fill text-xl"></i>
              <span>100% gratuito</span>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Sticky Button */}
      <a
        href="https://wa.me/34123456789?text=Hola,%20me%20gustaría%20solicitar%20una%20auditoría%20energética%20para%20mi%20empresa"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-16 h-16 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center text-white shadow-2xl hover:scale-110 transition-transform z-50 cursor-pointer"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </a>

      <Footer />
    </div>
  );
}
